import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useBaseStore } from '@/stores/base.store'

const sharedSearch = ref('')
const sharedLoading = ref(false)
const sharedSelectedUser = ref<any>(null)

export function useUserData() {
	const baseStore = useBaseStore()
	const { users } = storeToRefs(baseStore)

	const search = sharedSearch
	const isLoading = sharedLoading

	const filteredUsers = computed(() => {
		const term = search.value.toLowerCase()
		return (users.value || []).filter((u: any) => JSON.stringify(u).toLowerCase().includes(term))
	})

	const loadUsers = async () => {
		try {
			if (isLoading.value) return
			isLoading.value = true
			if (!users.value?.length) await baseStore.fetchUsers()
		} finally {
			isLoading.value = false
		}
	}

	return {
		users,
		search,
		isLoading,
		filteredUsers,
		loadUsers,
		selectedUser: sharedSelectedUser,
	}
}
